var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16C15.1716 16 14.5 16.6716 14.5 17.5C14.5 18.3284 15.1716 19 16 19C16.8284 19 17.5 18.3284 17.5 17.5C17.5 16.6716 16.8284 16 16 16ZM12.5 17.5C12.5 15.567 14.067 14 16 14C17.933 14 19.5 15.567 19.5 17.5C19.5 19.433 17.933 21 16 21C14.067 21 12.5 19.433 12.5 17.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 19C16.5523 19 17 19.4477 17 20V23C17 23.5523 16.5523 24 16 24C15.4477 24 15 23.5523 15 23V20C15 19.4477 15.4477 19 16 19Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 10.8954 4.89543 10 6 10H26C27.1046 10 28 10.8954 28 12V26C28 27.1046 27.1046 28 26 28H6C4.89543 28 4 27.1046 4 26V12ZM26 12H6V26H26V12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3C15.0717 3 14.1815 3.36875 13.5251 4.02513C12.8687 4.6815 12.5 5.57174 12.5 6.5V11C12.5 11.5523 12.0523 12 11.5 12C10.9477 12 10.5 11.5523 10.5 11V6.5C10.5 5.04131 11.0795 3.64236 12.1109 2.61091C13.1424 1.57946 14.5413 1 16 1C17.4587 1 18.8576 1.57946 19.8891 2.61091C20.9205 3.64236 21.5 5.04131 21.5 6.5V11C21.5 11.5523 21.0523 12 20.5 12C19.9477 12 19.5 11.5523 19.5 11V6.5C19.5 5.57174 19.1313 4.6815 18.4749 4.02513C17.8185 3.36875 16.9283 3 16 3Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.61251d3847acd6a56241c50c71cb1263.svg";
export { ForwardRef as ReactComponent };